import { render } from "./ExtensionsView.vue?vue&type=template&id=6730571a&scoped=true"
import script from "./ExtensionsView.vue?vue&type=script&lang=js"
export * from "./ExtensionsView.vue?vue&type=script&lang=js"

import "./ExtensionsView.vue?vue&type=style&index=0&id=6730571a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6730571a"]])

export default __exports__